//import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
//import slideshowCtrl        from './slideshowCtrl';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'slideshow-type-strip';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);
        setTimeout( () => this.initSlider(true), 17 );
	}

    initSlider(b){
        this.addEvents( b );      
    }

    delayInit(){
        //this.$el.find( '.slider-container' ).addClass( 'ready' );
    }

    addEvents(b){
        this.debounceResize(b);
    }
    //---------------------------------------- COMMONS -----------------------------------------//
    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 137 );
            this.$win.on( 'resize', this._debResize );
            if ( b ){
                this.onResize();
            }
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    // where the magic happen
    onResize(){
        let $header = this.$el.find( '.module-header' ), 
            h = this.$el.find( '.image-sizer' ).height(), 
            $dots = this.$el.find( '.slick-dots' ), 
            hh = this.$el.find( '.slick-track').height(),
            margen = Math.abs( parseInt( this.$el.find( '.slick-slider' ).css( 'margin-right' ) ) ),
            padding = parseInt( $header.find( '.layout-header' ).css('padding-left') ),
            w = this.$win.width();


            if ( this.$html.attr( 'dir' ) === 'rtl' ){

                margen = Math.abs( parseInt( this.$el.find( '.slick-slider' ).css( 'margin-left' ) ) );

                if ( w < 1024 ){
                    $dots.css({
                        'bottom' : hh - h + 15,
                        'right' : - ( w<768 ? 10 : 20 )
                    })
                }
                else{
                    $dots.css({
                        'bottom' : hh - h + 15,
                        'right' : 0 - $header.outerWidth() - margen + padding 
                    })
                }
            }
            else{
                if ( w < 1024 ){
                    $dots.css({
                        'bottom' : hh - h + 15,
                        'left' : - ( w<768 ? 10 : 20 )
                    })
                }
                else{
                    $dots.css({
                        'bottom' : hh - h + 15,
                        'left' : 0 - $header.outerWidth() - margen + padding 
                    })
                }
            }

        //console.log( h );

        $header.height( h );
    }   
    destroy(){
		if ( this.$el.length > 0){
            this.initSlider( false );
    	}
    }

}


